module.exports = __webpack_public_path__ + "images/hondaf14b6ce001fa3146343fc302a5fd8b5c.png";